import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=3d11f236&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"
import style0 from "./Body.vue?vue&type=style&index=0&id=3d11f236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11f236",
  null
  
)

export default component.exports